<template>
<div class="index-goods-info">
    <GoodsInfo></GoodsInfo>
</div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{

    },
    created(){

    },
    props:{
        
    }
}
</script>

<style lang="scss">
.index-goods-info{
}
</style>